module.exports = __webpack_public_path__ + "img/Share.d32e8279.svg";